const Marionette = require('backbone.marionette');
const templates = require('../templates');

module.exports = Marionette.ItemView.extend({
  className: 'course',
  template: templates.popup_footer_activity,
  serializeModel() {
    return {
      course: this.model,
      hour: this.getOption('hour')
    };
  },
  modelEvents: {
    change: 'render'
  }
});



// WEBPACK FOOTER //
// ./src/views/popup_footer_activity.js